import React from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from './Avatar';
import StarRating from './StarRating';

export default function DoctorCard({ doctor, sponsored = false }) {
  const navigate = useNavigate();
  const qual     = doctor.qualifications?.[0];

  return (
    <div
      className="card-p flex gap-3 cursor-pointer active:opacity-80"
      onClick={() => navigate(`/doctor/${doctor._id}`)}
    >
      {sponsored && (
        <span className="absolute top-3 right-3 badge badge-warning text-[9px]">AD</span>
      )}
      <Avatar src={doctor.profileImg} name={doctor.name} size="md" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-text-primary text-sm truncate">{doctor.name}</p>
        <p className="text-xs text-primary truncate">{doctor.speciality}</p>
        {qual && (
          <p className="text-xs text-text-muted truncate">
            {qual.degree} · {qual.hospital || doctor.clinicName}
          </p>
        )}
        <div className="flex items-center justify-between mt-1.5">
          <StarRating rating={doctor.rating} count={doctor.reviewCount} />
          {doctor.consultationFee > 0 && (
            <span className="text-xs text-text-secondary">₹{doctor.consultationFee}</span>
          )}
        </div>
      </div>
      <div className="flex items-center">
        <button
          className="bg-primary text-white text-xs font-semibold px-3 py-1.5 rounded-lg"
          onClick={(e) => { e.stopPropagation(); navigate(`/doctor/${doctor._id}`); }}
        >
          Book
        </button>
      </div>
    </div>
  );
}
